import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useConfigs } from '../contexts/ConfigsContext';

// Mapa storageKey -> secao do ConfigsContext (fonte de verdade DB-first).
// Mantido em paridade com STORAGE_MAP do ConfigsContext.
const STORAGE_TO_SECTION = {
  configVendas: 'vendas',
  configPcp: 'pcp',
  configProduto: 'produto',
  configExpedicao: 'expedicao',
  configCreditoLoja: 'creditoloja',
  configFinanceiro: 'financeiro',
  configFiscalOrigemTributacao: 'fiscal',
};

// Guard generico baseado em flag das configs centralizadas.
// Antes lia direto do localStorage (race condition: redirecionava antes
// do sync DB->localStorage rodar). Agora aguarda `loaded` do context.
const ConfigLocalStorageGuard = ({ storageKey, flag, equalsValue, children }) => {
  const { configs, loaded } = useConfigs();

  // Enquanto a primeira resposta do backend nao chegou, nao decide redirect
  // — evita "flash" para /inicio de quem chega via deep link.
  if (!loaded) {
    return null;
  }

  const secao = STORAGE_TO_SECTION[storageKey];
  let valor;
  if (secao && configs[secao]) {
    valor = configs[secao][flag];
  } else {
    // Fallback: chave nao mapeada — le do localStorage (compat)
    try {
      const stored = localStorage.getItem(storageKey);
      const parsed = stored ? JSON.parse(stored) : {};
      valor = parsed[flag];
    } catch {
      valor = undefined;
    }
  }

  const ativo = Number(valor) === Number(equalsValue);
  if (!ativo) {
    return <Navigate to="/inicio" replace />;
  }
  return children;
};

ConfigLocalStorageGuard.propTypes = {
  storageKey: PropTypes.string.isRequired,
  flag: PropTypes.string.isRequired,
  equalsValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
};

ConfigLocalStorageGuard.defaultProps = {
  equalsValue: 1,
};

export default ConfigLocalStorageGuard;
